import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";

export const containerStyle = recipe({
  base: {
    width: "100%",
    overflow: "hidden",
    ":focus-visible": {
      outline: "none",
    },
  },
});

export const optionLabelStyle = recipe({
  base: {
    lineHeight: 1.2,
  },
});

export const noResultsStyle = recipe({
  base: {
    lineHeight: 1.2,
    fontStyle: "italic",
    padding: theme.spacings.xs,
    whiteSpace: "nowrap",
    color: theme.colors.placeholder,
  },
});

export const menuStyle = recipe({
  base: {
    width: "100%",
    overflow: "hidden",
    gap: theme.spacings.xxs2,
  },
});

export const scrollStyle = style({
  maxHeight: rem(220),
  ":focus-visible": {
    outline: "none",
  },
});

export const scrollContentStyle = style({
  padding: theme.spacings.xs,
});

export const searchContainerStyle = style({
  padding: `${theme.spacings.s} ${theme.spacings.s} 0 ${theme.spacings.s}`,
});
